'use strict';

module.exports = function (Molecule) {
    var fields = new Map();

    fields.set('oclid', Molecule.fromIDCode);
    fields.set('idcode', Molecule.fromIDCode);
    fields.set('smiles', Molecule.fromSmiles);
    fields.set('molfile', Molecule.fromMolfile);

    return fields;
};


// WEBPACK FOOTER //
// ./node_modules/openchemlib-extended/lib/db/moleculeCreators.js